"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ticketFields = exports.helpTabs = exports.getTicketTab = void 0;
var assets_1 = require("@pbl/pbl-react-web-components/lib/config/assets");
var entryCodeRegex = /[a-zA-Z0-9#%&]/;
var gameNumberField = {
    type: 'string',
    key: 'gameNumber',
    label: 'Game Number',
    get placeholder() {
        return this.label;
    },
    isRequired: true,
    get fieldValue() {
        return this.value;
    }
};
var bookNumberField = {
    type: 'string',
    key: 'bookNumber',
    label: 'Book Number',
    get placeholder() {
        return this.label;
    },
    isRequired: true,
    get fieldValue() {
        return this.value;
    }
};
var ticketNumberField = {
    type: 'string',
    key: 'ticketNumber',
    label: 'Ticket Number',
    get placeholder() {
        return this.label;
    },
    isRequired: true,
    get fieldValue() {
        return this.value;
    }
};
var validationCodeField = {
    type: 'string',
    key: 'validationCode',
    label: 'VIRN Number',
    get placeholder() {
        return this.label;
    },
    isRequired: true,
    get fieldValue() {
        return this.value;
    }
};
var getTicketTab = function (enableQuickDraw) { return [
    {
        tabLogo: assets_1.assets.internalAssets.mnlogo,
        tabAltText: '',
        tabKey: 'scratchTicket',
        tabTitle: 'ticket.scratch.tabTitle',
        fields: [
            {
                key: 'ticketNumber',
                label: 'ticket.scratch.ticketNumberLabel',
                placeholder: '0000',
                maskKey: 'TicketBarcodeInputMask',
                mask: [/[0-9]/, /\d/, /\d/, /\d/],
                min: 4,
                numbersOnly: true,
                errorText: 'ticket.scratch.ticketNumberErrorText'
            },
            {
                key: 'validationCodeText',
                label: 'ticket.scratch.entryCodeLabel',
                placeholder: '##########',
                maskKey: 'TicketValidationInputMask',
                min: 10,
                mask: [/[0-9a-zA-Z]/, /\w/, /\w/, /\w/, /\w/, /\w/, /\w/, /\w/, /\w/, /\w/],
                numbersOnly: false,
                errorText: 'ticket.scratch.entryCodeErrorText'
            }
        ],
        sampleImageLink: 'ticket.sampleImageLink',
        sampleImage: 'SAMPLE_SCRATCH_TICKET_KEY',
        eligibleGamesEnabled: true,
        eligibleGameText: 'ticket.eligibleGames',
        eligibleGameLinkText: 'ticket.eligibleGamesLink'
    },
    {
        tabLogo: enableQuickDraw ? assets_1.assets.internalAssets.lottoTicket : assets_1.assets.internalAssets.printNPlay,
        tabAltText: '',
        tabKey: 'drawTicket',
        tabTitle: enableQuickDraw ? 'ticket.draw.tabFullTitle' : 'ticket.draw.tabTitle',
        fields: [
            {
                key: 'drawTicketNumber',
                label: 'ticket.draw.entryCodeLabel',
                placeholder: '########################',
                maskKey: 'TicketEntryCodeInputMask',
                mask: [
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex,
                    entryCodeRegex
                ],
                min: 24,
                numbersOnly: false,
                withSpecialCharacters: true,
                errorText: 'ticket.draw.entryCodeErrorText'
            }
        ],
        sampleImageLink: 'ticket.sampleImageLink',
        sampleImage: enableQuickDraw ? 'SAMPLE_DRAW_QUICK_DRAW_TICKET_KEY' : 'SAMPLE_DRAW_TICKET_KEY',
        eligibleGamesEnabled: true,
        eligibleGameText: 'ticket.eligibleGames',
        eligibleGameLinkText: 'ticket.eligibleGamesLink'
    }
]; };
exports.getTicketTab = getTicketTab;
exports.helpTabs = [
    {
        tabKey: 'scratchTicket',
        tabTitle: 'ticket.scratch.tabTitle',
        sampleImage: 'SAMPLE_SCRATCH_TICKET_KEY',
        parentTabKey: 'scratchTicket'
    },
    {
        tabKey: 'drawTicket',
        tabTitle: 'ticket.draw.tabTitle',
        sampleImage: 'SAMPLE_DRAW_TICKET_KEY',
        parentTabKey: 'drawTicket'
    }
];
exports.ticketFields = [
    gameNumberField,
    bookNumberField,
    ticketNumberField,
    validationCodeField
];
//# sourceMappingURL=ticket.js.map